// Frontend-only value set for the runs surface. See enums/shell.ts for the rationale.

export const RUN_FAILURE_KINDS = [
  "assessment",
  "capture",
  "incomplete",
] as const;
export type RunFailureKind = (typeof RUN_FAILURE_KINDS)[number];
export const RUN_FAILURE_KIND = {
  ASSESSMENT: "assessment",
  CAPTURE: "capture",
  INCOMPLETE: "incomplete",
} as const satisfies Record<string, RunFailureKind>;
